import { createContext, useContext, useState, useCallback } from "react";

export const ASSETS = {
  logo: "/assets/logo.png",
  mercedes: "/assets/mercedes.png",
  ducati: "/assets/ducati.png",
};

export const CONTACT = {
  phone: "+41 76 578 79 14",
  phoneHref: "tel:+41765787914",
  email: "contact@45detaillinggva.ch",
  instagram: "@45detaillinggva",
  instagramHref: "https://instagram.com/45detaillinggva",
};

const dict = {
  fr: {
    nav: { services: "Services", auto: "Auto", moto: "Moto", gallery: "Galerie", downloads: "Médias", contact: "Contact", book: "Réserver" },
    hero: {
      tag: "Detailing Premium · Genève",
      titleA: "L'art du",
      titleB: "détail absolu",
      sub: "Service de detailing & valet automobile et moto, entièrement mobile et autonome. Nous venons à vous — domicile ou lieu de travail — avec un équipement professionnel complet.",
      ctaPrimary: "Découvrir les tarifs",
      ctaSecondary: "Nous contacter",
      stat1: "Mobile & autonome",
      stat2: "Auto · Moto",
      stat3: "Produits premium",
    },
    about: {
      tag: "Qui sommes-nous",
      title: "Un atelier qui vient à vous",
      body: "45 Detailing GVA réinvente le soin automobile à Genève. Notre unité mobile entièrement équipée et autonome transforme chaque intervention en une expérience de prestige, sans déplacement de votre part.",
      f1Title: "Service Valet",
      f1Body: "Prise en charge et restitution de votre véhicule à domicile ou au bureau.",
      f2Title: "Unité Autonome",
      f2Body: "Eau, énergie et matériel professionnel embarqués — aucune contrainte technique.",
      f3Title: "Finition Concours",
      f3Body: "Décontamination, protection céramique et soins cuir d'exception.",
      f4Title: "Auto & Moto",
      f4Body: "Une expertise dédiée pour les voitures comme pour les deux-roues.",
    },
    pricing: {
      tag: "Tarifs",
      title: "Nos formules",
      sub: "Des prestations transparentes pour l'auto et la moto. Prix dès, selon l'état et la taille du véhicule.",
      auto: "Auto",
      moto: "Moto",
      interior: "Intérieur",
      exterior: "Extérieur",
      combo: "Combo Intérieur + Extérieur",
      from: "dès",
      included: "Inclus",
      book: "Réserver cette formule",
      comboTitle: "Packs Combo",
      comboSub: "Combinez intérieur et extérieur et profitez d'un rabais de 25%.",
      comboDiscount: "Rabais combo −25%",
      withDiscount: "avec rabais",
      withoutDiscount: "sans rabais",
      motoNote: "Motos spéciales sur devis (ex. Cruiser & Custom).",
      autoNote: "Sur devis pour les poils d'animaux.",
      motoTypes: "Roadster · Sportive · Trail",
      currency: "CHF",
    },
    gallery: {
      tag: "Réalisations",
      title: "Avant / Après",
      sub: "Glissez pour révéler la transformation. Un aperçu de notre exigence du détail.",
      before: "Avant",
      after: "Après",
    },
    pano: {
      tag: "Bientôt",
      title: "Le setup autonome en HD",
      sub: "Une photo panoramique haute définition de notre unité mobile complète arrive prochainement — le service auto autonome et valet réuni en un seul lieu.",
      soon: "Panorama HD à venir",
    },
    downloads: {
      tag: "Médias à télécharger",
      title: "Emportez 45 Detailing GVA",
      sub: "Carte de visite recto-verso et flyer pliable façon accordéon — en image haute qualité, prêts à imprimer.",
      cardTitle: "Carte de visite",
      cardSub: "Recto-verso · qualité impression",
      cardRecto: "Recto",
      cardVerso: "Verso",
      flyerTitle: "Flyer accordéon",
      flyerSub: "Format 15 × 18 cm · pli accordéon 3 volets",
      flyerRecto: "Recto (extérieur)",
      flyerVerso: "Verso (intérieur)",
      download: "Télécharger PNG",
      downloading: "Génération…",
      foldHint: "Pliez en accordéon : le volet Mercedes reste visible en façade, idéal à déposer sur les véhicules.",
    },
    contact: {
      tag: "Contact",
      title: "Réservez votre intervention",
      sub: "Un message, un appel — et notre unité mobile prend la route vers vous.",
      phone: "Téléphone",
      email: "E-mail",
      insta: "Instagram",
      zone: "Zone",
      zoneValue: "Genève & environs · à domicile ou au travail",
      cta: "Écrire sur WhatsApp",
    },
    footer: {
      rights: "Tous droits réservés.",
      tagline: "Detailing & valet premium, mobile et autonome — Genève.",
    },
    card: {
      role: "Premium Auto & Moto Detailing",
      tagline: "Mobile · Autonome · Valet",
      city: "Genève, Suisse",
      services: "Detailing · Céramique · Cuir · Valet",
    },
    flyer: {
      coverKicker: "Genève",
      coverTitle: "Detailing\nd'exception",
      coverSub: "Auto & Moto · Service valet mobile",
      open: "Ouvrez →",
      insideTitle: "Le luxe du détail,\nlivré chez vous",
      insideBody: "Notre unité mobile autonome prend soin de votre véhicule où que vous soyez — domicile ou bureau. Décontamination, protection céramique, soins cuir et finition concours.",
      bullet1: "Prise en charge & restitution",
      bullet2: "Équipement pro embarqué",
      bullet3: "Auto · Moto · Céramique",
      pricesTitle: "Formules dès",
      autoFrom: "Auto dès 110 CHF",
      motoFrom: "Moto dès 120 CHF",
      comboFrom: "Combo −25%",
    },
  },
  en: {
    nav: { services: "Services", auto: "Auto", moto: "Moto", gallery: "Gallery", downloads: "Media", contact: "Contact", book: "Book" },
    hero: {
      tag: "Premium Detailing · Geneva",
      titleA: "The art of",
      titleB: "absolute detail",
      sub: "Fully mobile and self-sufficient car & motorcycle detailing and valet service. We come to you — home or workplace — with complete professional equipment.",
      ctaPrimary: "View pricing",
      ctaSecondary: "Get in touch",
      stat1: "Mobile & autonomous",
      stat2: "Car · Bike",
      stat3: "Premium products",
    },
    about: {
      tag: "Who we are",
      title: "A studio that comes to you",
      body: "45 Detailing GVA reinvents car care in Geneva. Our fully equipped, self-sufficient mobile unit turns every appointment into a prestige experience — with zero effort on your side.",
      f1Title: "Valet Service",
      f1Body: "We pick up and return your vehicle at your home or office.",
      f2Title: "Autonomous Unit",
      f2Body: "Water, power and professional gear on board — no technical constraints.",
      f3Title: "Concours Finish",
      f3Body: "Decontamination, ceramic protection and exceptional leather care.",
      f4Title: "Car & Bike",
      f4Body: "Dedicated expertise for cars as well as two-wheelers.",
    },
    pricing: {
      tag: "Pricing",
      title: "Our packages",
      sub: "Transparent services for cars and motorcycles. Prices from, depending on vehicle size and condition.",
      auto: "Car",
      moto: "Motorcycle",
      interior: "Interior",
      exterior: "Exterior",
      combo: "Combo Interior + Exterior",
      from: "from",
      included: "Included",
      book: "Book this package",
      comboTitle: "Combo Packs",
      comboSub: "Combine interior and exterior and enjoy a 25% discount.",
      comboDiscount: "Combo discount −25%",
      withDiscount: "with discount",
      withoutDiscount: "without discount",
      motoNote: "Special motorcycles on quote (e.g. Cruiser & Custom).",
      autoNote: "Pet hair on quote.",
      motoTypes: "Roadster · Sport · Trail",
      currency: "CHF",
    },
    gallery: {
      tag: "Our work",
      title: "Before / After",
      sub: "Drag to reveal the transformation. A glimpse of our obsession with detail.",
      before: "Before",
      after: "After",
    },
    pano: {
      tag: "Coming soon",
      title: "The autonomous setup in HD",
      sub: "A high-definition panoramic photo of our complete mobile unit is coming soon — autonomous car service and valet in one place.",
      soon: "HD panorama coming soon",
    },
    downloads: {
      tag: "Downloadable media",
      title: "Take 45 Detailing GVA with you",
      sub: "Double-sided business card and accordion-fold flyer — as high-quality images, ready to print.",
      cardTitle: "Business card",
      cardSub: "Double-sided · print quality",
      cardRecto: "Front",
      cardVerso: "Back",
      flyerTitle: "Accordion flyer",
      flyerSub: "15 × 18 cm format · 3-panel accordion fold",
      flyerRecto: "Front (outside)",
      flyerVerso: "Back (inside)",
      download: "Download PNG",
      downloading: "Generating…",
      foldHint: "Accordion fold: the Mercedes panel stays on the front — perfect to leave on vehicles.",
    },
    contact: {
      tag: "Contact",
      title: "Book your appointment",
      sub: "One message, one call — and our mobile unit hits the road to you.",
      phone: "Phone",
      email: "Email",
      insta: "Instagram",
      zone: "Area",
      zoneValue: "Geneva & surroundings · at home or at work",
      cta: "Message on WhatsApp",
    },
    footer: {
      rights: "All rights reserved.",
      tagline: "Premium, mobile and autonomous detailing & valet — Geneva.",
    },
    card: {
      role: "Premium Auto & Moto Detailing",
      tagline: "Mobile · Autonomous · Valet",
      city: "Geneva, Switzerland",
      services: "Detailing · Ceramic · Leather · Valet",
    },
    flyer: {
      coverKicker: "Geneva",
      coverTitle: "Exceptional\ndetailing",
      coverSub: "Car & Bike · Mobile valet service",
      open: "Open →",
      insideTitle: "The luxury of detail,\ndelivered to you",
      insideBody: "Our autonomous mobile unit takes care of your vehicle wherever you are — home or office. Decontamination, ceramic protection, leather care and a concours finish.",
      bullet1: "Pick-up & return",
      bullet2: "On-board pro equipment",
      bullet3: "Car · Bike · Ceramic",
      pricesTitle: "Packages from",
      autoFrom: "Car from 110 CHF",
      motoFrom: "Bike from 120 CHF",
      comboFrom: "Combo −25%",
    },
  },
};

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState("fr");
  const toggle = useCallback(() => setLang((l) => (l === "fr" ? "en" : "fr")), []);
  const t = dict[lang];
  return (
    <LanguageContext.Provider value={{ lang, setLang, toggle, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLang() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
}
